import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faPause } from '@fortawesome/free-solid-svg-icons'

function HeaderBar(props) {
  const name = (props.currentStation) ? props.currentStation.name : '';
  const isPlaying = (props.isPlaying) ? props.isPlaying : '';
  const iconDef = (isPlaying) ? faPause : faPlay;
  return (
    <header>
      <div className="header-bar">
        <button id="toggleButton" onClick={props.playToggle}>
          <FontAwesomeIcon icon={iconDef} />
        </button>
        <span className='stationName'>{name}</span>
     
      </div>
    </header>
  );
}

export default HeaderBar;
